import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from { transform: translate(-50%, 8px); opacity: 0; }
  to { transform: translate(-50%, 0); opacity: 1; }
`;

const slideDown = keyframes`
  from { transform: translate(-50%, 0); opacity: 1; }
  to { transform: translate(-50%, 8px); opacity: 0; }
`;

export const BarWrapper = styled.div`
  position: fixed;
  bottom: 72px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;

  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 8px;

  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0 4px 13px 0 rgba(0, 0, 0, 0.15);

  animation: ${slideUp} 160ms ease;

  &.exiting {
    animation: ${slideDown} 160ms ease forwards;
  }
`;

export const CountText = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AnchorSizer = styled.div`
  position: fixed;
  bottom: 72px;
  left: 0;
  right: 0;
  pointer-events: none;
`;

export const CountNumber = styled.span`
  display: flex;
  width: 20px;
  height: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  aspect-ratio: 1/1;
  border-radius: 100px;
  background: ${({ theme }) => theme.colors.black10};
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;
